import { makeAutoObservable } from "mobx";
import { ApiService } from "@/api";
import { SigningMethod } from "@/common/common";

export class SigningModel {
  documentReference: string | null;
  state:
    | "ready"
    | "authorizationCodeSent"
    | "errorHandlingSignRequest"
    | "documentSigned"
    | "errorSendingHandwrittenSignature"
    | "errorVerifyingAuthorizationCode"
    | "handwrittenSignatureReady"
    | "sendingHandwrittenSignature"
    | "awaitHandwrittenSignature" = "ready";

  constructor(
    private apiService: ApiService,
    documentReference: string | null,
  ) {
    this.sendHandwrittenSignature = this.sendHandwrittenSignature.bind(this);
    this.documentReference = documentReference;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  *signRequest(signingMethod: SigningMethod | undefined) {
    if (!this.documentReference || !signingMethod) return false;
    try {
      switch (signingMethod) {
        case SigningMethod.AUTH_EMAIL:
          yield this.apiService.signWithEmail(this.documentReference);
          this.state = "authorizationCodeSent";
          break;
        case SigningMethod.HANDWRITING:
          this.state = "awaitHandwrittenSignature";
          break;
        case SigningMethod.BANKID_AUTH:
          location.href = `/api/document/sign-with-bankid-auth/${this.documentReference}`;
          break;
        case SigningMethod.BANKID_SWEDEN_AUTH:
          location.href = `/api/document/sign-with-bankid-sweden-auth/${this.documentReference}`;
          break;
        default:
          break;
      }
    } catch (err) {
      this.state = "errorHandlingSignRequest";
    }
  }

  isSendingHandwrittenSignature(): boolean {
    return this.state === "sendingHandwrittenSignature";
  }

  setIsSendingHandwrittenSignature() {
    this.state = "sendingHandwrittenSignature";
  }

  *sendHandwrittenSignature(base64EncodedImage: string) {
    if (!this.documentReference) return false;
    try {
      const formData = new FormData();
      formData.append("base64EncodedImage", base64EncodedImage);
      yield this.apiService.signWithHandWriting(this.documentReference, formData);
      this.state = "documentSigned";
    } catch (err) {
      this.state = "errorSendingHandwrittenSignature";
    }
  }

  *codeVerify(code: string) {
    if (!this.documentReference) return false;
    try {
      yield this.apiService.signVerifyWithCode(
        this.documentReference,
        encodeURI(code.replace(/[^a-z0-9]/gi, "")),
      );
      this.state = "documentSigned";
    } catch (err) {
      this.state = "errorVerifyingAuthorizationCode";
    }
  }
}
